import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store'; // adjust path as needed

interface NotificationRefreshState {
  refresh: boolean;
}

const initialState: NotificationRefreshState = {
  refresh: false,
};

export const notificationRefreshSlice = createSlice({
  name: 'notificationRefresh',
  initialState,
  reducers: {
    setRefresh: (state, action: PayloadAction<boolean>) => {
      state.refresh = action.payload;
    },
  },
});

// Export action
export const { setRefresh } = notificationRefreshSlice.actions;

// Selector
export const selectNotificationRefresh = (state: RootState) => state.notificationRefresh.refresh;

// Export reducer
export default notificationRefreshSlice.reducer;
